// Module
var code = "<div aria-hidden=\"true\" class=\"onboarding_modal__dialog\" ng-transclude role=\"dialog\" tabindex=\"-1\"></div>";
// Exports
export default code;